var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M26 13.0852C26 5.84716 20.1627 0 13 0C5.83731 0 0 5.84716 0 13.0852C0 19.6135 4.76573 25.0349 10.9696 26V16.8603H7.67028V13.0852H10.9696V10.19C10.9696 6.92577 12.9154 5.10917 15.8764 5.10917C17.2863 5.10917 18.7809 5.36463 18.7809 5.36463V8.57205H17.1453C15.538 8.57205 15.0304 9.59389 15.0304 10.6157V13.0568H18.6399L18.0759 16.8319H15.0304V25.9716C21.2343 25.0349 26 19.6135 26 13.0852Z","fill":"white"}));
}

IconFacebook.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
